import axios from "@/plugins/axios";

let url = "/api/console/shop/purchases";

export default {
    getPurchases(data){
        return axios.get(url, data).then(result => result.data);
    },
    postPurchase(data){
        return axios.post(url, data).then(result => result.data);
    },
    putPurchase(data){
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    },
    deletePurchase(data){
        return axios.delete(`${url}/${data._id}`).then(result => result.data);
    },
    getDashboard(data){
        return axios.get(`${url}/dashboard/${data.manage}`).then(result => result.data);
    }
}
